import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import trans from '../../translations.json';

let results;

class ActiveOutbreaksTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  categories = [
    trans.activeOutbreaks.groupCare[this.props.lang],
    trans.activeOutbreaks.groupLiving[this.props.lang],
    trans.activeOutbreaks.groupEducation[this.props.lang],
    trans.activeOutbreaks.groupRecreational[this.props.lang],
    trans.activeOutbreaks.groupWorkplace[this.props.lang],
    trans.activeOutbreaks.groupOther[this.props.lang],
  ];

  getData(data, category) {
    let result = [];
    let title;
    let total = 0;
    switch (category) {
      case this.categories[0]:
        result = [
          '1 Long-Term Care Homes',
          '2 Hospitals',
          '3 Retirement Homes',
        ];
        title = this.categories[0];
        break;
      case this.categories[1]:
        result = [
          '4 Group Home/Supportive Housing',
          '5 Correctional Facility',
          '6 Shelter',
          '18 Short-term accommodations',
          '22 Congregate other',
        ];
        title = this.categories[1];
        break;
      case this.categories[2]:
        result = [
          '11 Child care',
          '7 School - Elementary',
          '8 School - Secondary',
          '9 School - Elementary/Secondary',
          '10 School - Post-Secondary',
        ];
        title = this.categories[2];
        break;
      case this.categories[3]:
        result = [
          '17 Bar/restaurant/nightclub',
          '19 Recreational fitness',
          '20 Personal service settings',
          '21 Other recreation',
        ];
        title = this.categories[3];
        break;
      case this.categories[4]:
        result = [
          '12 Workplace - Farm',
          '13 Workplace - Food Processing',
          '15 Retail',
          '16 Medical/Health Service',
          '14 Workplace - Other',
        ];
        title = this.categories[4];
        break;
      case this.categories[5]:
        result = ['24 Unknown', '23 Other'];

        title = this.categories[5];
        break;
      default:
    }
    let sortedData = result.map((item, z) => {
      total += Number(
        ReducedData.dataActiveOutbreaks[item][
          'NUMBER OF ONGOING OUTBREAKS'
        ],
      );
      return {
        index: z,
        setting: trans.activeOutbreaks[item][this.props.lang],
        NumberOfOutbreaks: ReducedData.dataActiveOutbreaks[item][
          'NUMBER OF ONGOING OUTBREAKS'
        ].toLocaleString(),
      };
    });

    sortedData.push({
      index: sortedData.length,
      setting: trans.activeOutbreaks.total[this.props.lang],
      NumberOfOutbreaks: total.toLocaleString(),
    });

    const columns = [
      {
        title: title,
        dataIndex: 'setting',
        key: 'setting',
        width: '50%',
      },
      {
        title: trans.activeOutbreaks.numberOfOB[this.props.lang],
        dataIndex: 'NumberOfOutbreaks',
        key: 'NumberOfOutbreaks',
        width: '50%',
      },
    ];
    return [sortedData, columns];
  }

  render() {
    const keys = Object.keys(ReducedData.dataActiveOutbreaks);

    return (
      <>
        {this.categories.map((item, index) => {
          results = this.getData(keys, item);
          return (
            <div className="ontario-margin-bottom-32-!">
              <Table
                rowClassName={(record, index) =>
                  record.setting ===
                  trans.activeOutbreaks.total[this.props.lang]
                    ? 'table-total'
                    : ''
                }
                columns={results[1]}
                dataSource={results[0]}
                pagination={false}
                scroll={{ x: 300 }}
              />
            </div>
          );
        })}
      </>
    );
  }
}

export default ActiveOutbreaksTable;
